import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import { identifierModuleUrl } from '@angular/compiler';

@Injectable({
  providedIn: 'root'
})
export class ApiFormService {
  datosApi: any;

  /*public API_URL = 'http://10.130.51.23/formHonduras/public/insert';*/
  public API_URL = 'https://registro.mind.brm.co/formRegistro/accion/insert';

  constructor(
    private http: HttpClient
  ) {
  }

  private httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }
    )
  };

  postFormSave( name: any, phone: any, email: any, form: any) {
    let origen = window.location.search;
    console.log(origen);
    this.datosApi = {
      "name": name,
      "phone": phone,
      "email": email,
      "form" : form,
      "origen" : origen,
    };
    const datos = JSON.stringify(this.datosApi);
    return this.http.post( this.API_URL , datos);

  }
}
